'use client';

import Image from 'next/image';

interface EnquiryModalProps {
  showModal: boolean;
  closeModal: () => void;
}

const EnquiryModal = ({ showModal, closeModal }: EnquiryModalProps) => {
  if (!showModal) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 animate-fade-in" style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
      <div className="enquiry-modal bg-white rounded-[24px] max-w-[1085px] w-full mx-4 overflow-hidden animate-slide-up relative">
        <button 
          onClick={closeModal}
          className="absolute top-4 right-4 text-[#6e6672] hover:text-[#2E2A3A] transition-colors text-[24px] font-light z-10"
        >
          ×
        </button>
        <div className="flex flex-col md:flex-row">
          {/* Image Section */}
          <div className="enquiry-image w-[375px] relative h-[400px] md:h-auto">
            <Image 
              src="/popup-image.png" 
              alt="Fitness enquiry" 
              fill
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content Section */}
          <div className="enquiry-content p-[50px] flex-1">
            <h2 className="font-['Gotham_Rounded',sans-serif] text-[28px] font-bold text-[#2E2A3A] mb-2">
              Send an Enquiry
            </h2>
            <p className="subtext font-['Archivo',sans-serif] text-[16px] text-[#6e6672] mb-4">
              Contact this verified women-only, women-led fitness space directly.
            </p>

            <hr className="border-[#e5e5e5] mb-4" />

            <p className="note font-['Archivo',sans-serif] text-[14px] text-[#6e6672] mb-4">
              Your message will be send directly to the provider, Female Fitness Finder
              does not handle bookings.
            </p>

            <div className="verified flex items-center gap-2 mb-6">
              <span className="shield w-5 h-5 bg-[#8A7296] text-white rounded-full flex items-center justify-center text-[12px]">✓</span>
              <span className="font-['Archivo',sans-serif] text-[14px] text-[#2E2A3A]">Verified by Female Fitness Finder</span>
            </div>

            <form className="space-y-4">
              <div className="row flex gap-4">
                <input 
                  type="text" 
                  placeholder="First Name"
                  className="flex-1 px-4 py-3 border border-[#d7d7d7] rounded-[10px] font-['Archivo',sans-serif] text-[16px] focus:outline-none focus:border-[#8A7296] transition-colors"
                />
                <input 
                  type="text" 
                  placeholder="Last Name"
                  className="flex-1 px-4 py-3 border border-[#d7d7d7] rounded-[10px] font-['Archivo',sans-serif] text-[16px] focus:outline-none focus:border-[#8A7296] transition-colors"
                />
              </div>

              <input 
                type="email" 
                placeholder="Your email address"
                className="w-full px-4 py-3 border border-[#d7d7d7] rounded-[10px] font-['Archivo',sans-serif] text-[16px] focus:outline-none focus:border-[#8A7296] transition-colors"
              />

              <textarea 
                placeholder="Your message..."
                className="w-full px-4 py-3 border border-[#d7d7d7] rounded-[10px] font-['Archivo',sans-serif] text-[16px] focus:outline-none focus:border-[#8A7296] transition-colors resize-none"
                rows={4}
              />

              <button 
                type="submit"
                className="submit-btn w-full px-6 py-3 bg-[#8A7296] text-white rounded-[50px] font-['Archivo',sans-serif] text-[16px] font-medium hover:bg-[#7a647d] transition-colors flex items-center justify-center gap-2"
              >
                Send Enquiry ↗
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquiryModal;
